import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import React from 'react'

export default function PhoneNumber({ value, onChange, disabled }) {
  // return (
  //   <PhoneInput
  //     dropdownClass="my-dropdown-portal"
  //     disabled={disabled}
  //     country={'fr'}
  //     value={value}
  //     onChange={(value) => onChange(value)}
  //     preferredCountries={['fr', 'es']}
  //     inputStyle={{ width: '100%' }}
  //     enableSearch
  //   />
  // );

  return <PhoneInput value={value} onChange={v => onChange(v || null)} disabled={disabled} defaultCountry="FR" />
}
